export class LlmToneDTO {
    id: string;
    name: string;
    description: string;
    isSelected?: boolean;
  isDefault: boolean;

    constructor(data?: Partial<LlmToneDTO>) {
        if (data) {
            this.bindData(data);
        } else {
            this.initialize();
        }
    }

    bindData(data: Partial<LlmToneDTO>): void {
        if (data) {
            this.id = data.id || '';
            this.name = data.name || '';
            this.description = data.description || '';
            this.isSelected = data.isSelected || false;
            this.isDefault = data.isDefault || false;
        }
    }

    private initialize(): void {
        this.id = '';
        this.name = '';
        this.description = '';
        this.isSelected = false;
        this.isDefault = false;
    }
}
